<template>
  <v-card elevation="0" class="all-trade-tab rounded-0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-tabs v-model="tab" :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-tab class="ml-0"> Investor Accounts </v-tab>
      <v-tab>
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Live Orders
      </v-tab>
      <v-tab> History </v-tab>
      <v-tab-item>
        <InvestorAccountTab></InvestorAccountTab>
      </v-tab-item>
      <v-tab-item>
        <LiveOrderTab></LiveOrderTab>
      </v-tab-item>
      <v-tab-item>
        <HistoryTab></HistoryTab>
      </v-tab-item>

    </v-tabs>
  </v-card>
</template>

<script>
import HistoryTab from './HistoryTab';
import InvestorAccountTab from './InvestorAccountTab';
import LiveOrderTab from './LiveOrderTab';

import { mapActions } from "vuex";
import { MAM__ACTIONS,TRADING__ACTIONS } from "@/store/action-types";


export default {
  components: {
    InvestorAccountTab,
    LiveOrderTab,
    HistoryTab,
  },

  data() {
    return {
      tab: 0,
    }
  },

  watch: {
    tab(newVal) {
      const id = this.$route.query.id;
      if (!id) return;
      switch (newVal) {
        case 0:
          this.getInvestor(id);
          break;
        case 1:
          this.getLiveOrders(id);
          this.getBalance(id);
          break;
        case 2:
          this.getHistory(id);
          break;
      }
    },
  },

  methods: {
     ...mapActions("mam", {
      getInvestor: MAM__ACTIONS.MANAGERACCOUNTDETAILS,
      getLiveOrders: MAM__ACTIONS.LIVEORDERSMANAGERINVESTORS,
      getHistory: MAM__ACTIONS.ORDERHISTORYMANAGERINVESTORS
    }),

    ...mapActions("trading", {
      getBalance: TRADING__ACTIONS.MANAGERACCOUNTBALANCECARDDETAILS
    }),
  },

}
</script>
